import React, {createContext, FC, useState} from "react";
import {TabKey} from "../constants/tabs";
import {PropertyPageTabKey} from "../constants/propertyPageTabs";

// the open tab of the property page in the widget tab `field`
export type SavedPropertyPageTab = {
  field: TabKey;
  tab: PropertyPageTabKey;
}

/**
 * Keeps the open tab of the property page while the page remounts: the widget shows a loader
 * instead of the page while it reloads its data, after a language change.
 */
export const PropertyPageTabContext = createContext<
  [SavedPropertyPageTab | null, React.Dispatch<SavedPropertyPageTab | null>]
>([null, () => null]);

export const PropertyPageTabContextProvider: FC = ({ children }) => {
  const savedTabState = useState<SavedPropertyPageTab | null>(null);
  return (
    <PropertyPageTabContext.Provider value={savedTabState}>
      {children}
    </PropertyPageTabContext.Provider>
  );
};
